export default class ContactList {
  constructor(public Name: string, public Email: string) {}
}
